<template>
  <v-container>
    <v-row>
      <v-col>
        <h1 class="mb-4">Experience</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-timeline
          :dense="$vuetify.breakpoint.xsOnly"
          v-for="(item,index) in timeline"
          :key="index"
        >
          <v-timeline-item class="pb-0" left :fill-dot="fillDot" :small="small" :color="color">
            <span slot="opposite">{{ item.fromDate }} - {{ item.toDate }}</span>
            <v-col class="d-flex justify-end">
              <TimelineCardHome :image="item.image" :company="item.company" :position="item.title" />
            </v-col>
          </v-timeline-item>
        </v-timeline>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TimelineCardHome from "@/components/sub-components/TimelineCardHome.vue";
import experienceData from "@/store/experienceData.js";

export default {
  name: "Timeline",
  components: {
    TimelineCardHome
  },
  data: () => ({
    loadMore: false,
    dynamicButton: "more",
    fillDot: true,
    small: true,
    color: "#2c3e50",
    timeline: []
  }),
  computed: {
    // ...mapState(["timeline"])
  },
  methods: {
    experience() {
      this.loadMore = !this.loadMore;
      if (!this.loadMore) {
        this.dynamicButton = "more";
      } else {
        this.dynamicButton = "less";
      }
    },
  },
  mounted() {
    this.timeline = experienceData
  }
};
</script>

<style>
</style>